// Module
var code = "<table class=\"filter-list\"></table> <span class=\"icon fa fa-eye\" title=\"Drill-down filters\"></span> ";
// Exports
export default code;